import API from "../Services/API";
import Model from "./Model";
import State from "./State";

const useBlockedDates = (alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['blockedDates'],
        fetchData: () => API.get('/blockedDates'),
        returnDataKey: 'blockedDates',
        defaultLoadingError: 'Failed to load blocked dates.',
        saveAdditionalData: (response) => {
            if (Array.isArray(response)) {
                response.forEach((blockedDate) => {
                    State.putIfNotExists(['blockedDate', blockedDate.id], blockedDate);
                });
            }
        },
        registerAdditionalMethods: (opts) => {
            return {
                createBlockedDate: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/blockedDates', data),
                        null,
                        true,
                    );
                },
                updateBlockedDate: (blockedDateId, data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/blockedDates/${blockedDateId}`, data),
                        null,
                        true,
                    );
                },
                deleteBlockedDate: (blockedDateId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/blockedDates/${blockedDateId}`),
                        null,
                        true,
                    );
                },
            }
        }
    });
}

const blockedDateReasons = [
    { value: 'Holiday', label: 'Holiday' },
    { value: 'Maintenance', label: 'Maintenance' },
    { value: 'Job Scheduled', label: 'Job Scheduled' },
    { value: 'Other', label: 'Other' },
];

export {
    blockedDateReasons,
};

export default useBlockedDates;
